import * as Store from 'store';
import * as Types from './types';

export const getList = (state: Store.Types.IState): Types.IEntity.Document[] => {
  return state.assessment?.list?.items ?? [];
};

export const getListIsFetched = (state: Store.Types.IState): boolean => {
  return state.assessment?.list?.isFetched ?? false;
};

export const getListIsLoaded = (state: Store.Types.IState): boolean => {
  return state.assessment?.list?.isLoaded ?? false;
};
